/**
 * external libs
 */
import React, {useContext, useEffect, useMemo, useState} from 'react'
import {useTranslation} from "react-i18next";
/**
 * components
 */
import SideBar from '../SideBar'
import SideBarTop from './components/Top'
/**
 * styles
 */
import styles from './index.module.scss'
/**
 * utils
 */
import ParseMedicalCardApi from "../../utils/api/ParseMedicalCardApi";
/**
 * constants
 */
import {
    MEDICAL_CARDS_LIST_MAKE_PAGE_URI,
    MEDICAL_CARDS_MAKE_PAGE_URI,
    SETTINGS_CONTENT_PAGE_URI,
    SETTINGS_FODLERS_PAGE_URI,
    SETTINGS_DOCUMENTATION_USER_AGREEMENT_PAGE_URI,
    SETTINGS_DOCUMENTATION_PERSONAL_INFO_PAGE_URI,
    NOTIFICATIONS_PAGE_URI,
    SETTINGS_WIDGET_PAGE_URI,
    SETTINGS_SECURITY_PAGE_URI
} from "../../constants/uri.constant";
import generateIconUrl from "../../utils/generateIconUrl";
/**
 * enums
 */
import IncarnationIdEnum from "../../enums/api/Incarnation";
/**
 * context
 */
import {AuthContext} from "../../pages/context/auth.context";
import MedicalCardService from "../../services/medicalCard.service";
import FolderIdEnum from "../../enums/api/FolderId";
import {useHistory} from "react-router-dom";
import checkPermission from "../../utils/checkPermission";
import RolesEnums from "../../enums/api/Roles";
import {GlobalFolderContext} from "../../pages/context/globalFolder.context";
import formatFolderToSideBarItems from "../../utils/formatFolderToSideBarItems";


export default function Navigation({openSideBar, setOpenSideBar}){
    const {t, i18n} = useTranslation();
    const {user} = useContext(AuthContext)
    const {medicalCard} = useContext(AuthContext)
    const {setGlobalFolder} = useContext(GlobalFolderContext)
    const [sideBarFolderItems, setSideBarFolderItems] = useState([]);

    const setCurrentFolderHandler = (folder) => {
        setGlobalFolder(folder.folder)
    }

    const getMedicalCardWithoutRecord = async (params = {}) => {
        try {
            const folderForNavigation = medicalCard.folder.filter(folder => folder.incarnation.id !== IncarnationIdEnum.id.record)
            const folders = ParseMedicalCardApi.formatFoldersWithChildren(folderForNavigation)

            setSideBarFolderItems(folders.map( folder => {
                const sideBarItem = {
                    ...formatFolderToSideBarItems(folder, setCurrentFolderHandler),
                    children: folder.childrenFolder?.map(folder => formatFolderToSideBarItems(folder, setCurrentFolderHandler)) || null
                }

                if(sideBarItem.children){
                    delete sideBarItem.link
                    delete sideBarItem.hash
                }

                return sideBarItem
            }))
        }
        catch (e){
            setSideBarFolderItems([])
        }
    };

    useEffect(() => {
        getMedicalCardWithoutRecord()
    }, [medicalCard])

    return (
        <div className={`${styles.wrapper} ${!openSideBar ? styles.close : ""}`}>
            <SideBarTop setOpenSideBar={setOpenSideBar} openSideBar={openSideBar}/>
            <SideBar sideBarItems={sideBarFolderItems} openSideBar={openSideBar}/>
        </div>
    )
}
